import React, { memo, useCallback, useEffect, useMemo } from "react";

// core-ui components
import { LottieAnimation, withStyles } from "@swiggy-private/core-ui";

// styled component
import { ExpressContainer, LottieWrapper } from "./styles";

// utils
import { getCloudinaryUrl } from "@swiggy-private/js-utils";

// constants & data-testId's
import { DELIVERY_SPEED_WIDGET_TEST_IDS } from "@swiggy-private/cart-test-ids";
import { lottieProps } from "./constants";
import { EcoSaverLottieSuccess } from "@swiggy-private/cart-types";

const EcoSaverLottie = ({
    showExpressLottie = false,
    setShowExpressLottie,
    lottieId = "",
    onImpressionEcoSaverLottie,
    cartId,
    addressId,
    discountType,
}: EcoSaverLottieSuccess) => {
    const onLottieCompletion = useCallback(() => {
        setShowExpressLottie(false);
    }, [setShowExpressLottie]);

    const handleError = useCallback(() => {
        setShowExpressLottie(true);
    }, [setShowExpressLottie]);

    const lottiePath = useMemo(() => getCloudinaryUrl(lottieId), [lottieId]);

    useEffect(() => {
        if (showExpressLottie) onImpressionEcoSaverLottie(cartId, addressId, lottieId);
    }, [addressId, cartId, lottieId, onImpressionEcoSaverLottie, showExpressLottie]);

    if (!showExpressLottie) return null;

    return (
        <ExpressContainer discountType={discountType}>
            <LottieWrapper
                discountType={discountType}
                data-testid={DELIVERY_SPEED_WIDGET_TEST_IDS.DELIVERY_SPEED_NO_RUSH_ECO_SAVER_LOTTIE}
            >
                <LottieAnimation
                    {...lottieProps}
                    fileName={lottiePath}
                    visible={showExpressLottie}
                    playLottie={showExpressLottie}
                    autoplay={showExpressLottie}
                    onPlayComplete={onLottieCompletion}
                    enableFrameEvent
                    preserveAspect="xMinYMid slice"
                    onError={handleError}
                />
            </LottieWrapper>
        </ExpressContainer>
    );
};

export default memo(withStyles(EcoSaverLottie));
